export const filters_tmpl = {
    type_group:[
        {field:"2", label:"від 1-го до 2-х років", sublabel:"друга група раннього віку", default: true},
        {field:"3", label:"від 2-х до 3-х років", sublabel:"перша молодша група", default: true},
        {field:"4", label:"від 3-х до 4-х років", sublabel:"друга молодша група", default: true},
        {field:"5", label:"від 4-х до 5-ти років", sublabel:"середня група", default: true},
        {field:"6", label:"від 5-ти до 6(7) років", sublabel:"старша група", default: true},
        {field:"7", label:"від 6-ти до 7-ми років", sublabel:"підготовча до школи група", default: true},
        {field:"15", label:"окрема тимчасова", sublabel:"різновікова", default: true},
        {field:"16", label:"від 1-го до 3-ти років", sublabel:"різновікова", default: true},
        {field:"10", label:"від 3-х до 5-ти років", sublabel:"різновікова", default: true},
        {field:"11", label:"від 3-х до 6-ти років", sublabel:"різновікова", default: true},
        {field:"12", label:"від 4-х до 6-ти років", sublabel:"різновікова", default: true},
        {field:"17", label:"від 6 місяців до 1-го року", sublabel:"яслі", default: true},
        {field:"14", label:"від 1,5 року до 3 років", sublabel:"яслі", default: true},
    ],
    distr:[
        {field:"Голосіївський", label:"Голосіївський"},
        {field:"Дарницький", label:"Дарницький"},
        {field:"Деснянський", label:"Деснянський"},
        {field:"Дніпровський", label:"Дніпровський"},
        {field:"Оболонський", label:"Оболонський"},
        {field:"Печерський", label:"Печерський"},
        {field:"Подільський", label:"Подільський"},
        {field:"Святошинський", label:"Святошинський"},
        {field:"Солом'янський", label:"Солом'янський"},
        {field:"Шевченківський", label:"Шевченківський"}
    ],
    free_places:[
        {field:"standart", label:"спальних місць"},
        {field:"without-bed", label:"місць короткотривалого перебування"},
        {field:"inclusive", label:"місць інклюзивного перебування"},
        {field:"inclusive-short", label:"місць інклюзивного короткотривалого перебування"}
    ],
    specialization: [
    { field: 'general', label: 'Загального розвитку' },
    { field: 'combined', label: 'Комбінуючий' },
    { field: 'sanatorium', label: 'Санаторний' },
    { field: 'special', label: 'Спеціальний' }
    ],
    disease_type: [
        // Загальні захворювання для санаторного та комбінованого
        { field: 'tuberculosis', label: 'З латентною туберкульозною інфекцією та після вилікування від туберкульозу' },
        { field: 'respiratory', label: 'З хронічними неспецифічними захворюваннями органів дихання' },
        { field: 'cardiovascular', label: 'Із захворюваннями серцево-судинної системи' },
        { field: 'endocrine', label: 'Із захворюваннями ендокринної системи' },
        { field: 'digestive', label: 'З хворобами органів травлення' },
        { field: 'psychoneurological', label: 'З психоневрологічними захворюваннями' },
        
        // Спеціальні захворювання для спеціального та комбінованого
        { field: 'hearing', label: 'З порушеннями слуху (глухих, зі зниженим слухом)' },
        { field: 'vision', label: 'З порушеннями зору (сліпих, зі зниженим зором)' },
        { field: 'speech', label: 'З порушеннями мови' },
        { field: 'musculoskeletal', label: 'З порушеннями опорно-рухового апарату' },
        { field: 'intellectual', label: 'З розумовою відсталістю' },
        { field: 'developmental', label: 'Із затримкою психічного розвитку' }
    ]
};

export const getFilterObj = ()=>{
    const obj = {};

    Object.keys(filters_tmpl).forEach(f=>{
        obj[f] = {};
        filters_tmpl[f].forEach(k=>{
            obj[f][k.field]=k['default'] ? true : false;
        })
    });

    return obj;
}
